import fly, { FlyRequestConfig } from 'flyio'
import 'formdata-polyfill/FormData.js'
import * as md5 from 'md5'
import { Toast } from 'antd-mobile'
import { getVersion, getMallKey } from '@/util/storage'
import { phonePlatform } from '../util/util'
import { sige_app_key, sige_app_secret } from '@/util/const-key';
const version = getVersion()
const phoneFrom = phonePlatform()
const mallKey = getMallKey()
let key: any = ''

// 四格API的加密方式
const sigeRequest = (request: FlyRequestConfig)=>{
  const params = {
    requestId: `${Date.now()}`,
    requestTime: `${Date.now()}`,
    appKey: sige_app_key,
    noncestr: `${Date.now()}`,
    apiVersion: '1',
    data: request.body
  }
  const paramsStr = JSON.stringify(params)
  const strSign = paramsStr + '|' + sige_app_secret
  const signMD5 = md5(strSign)
  request.headers['signature'] = signMD5
  request.body = {
    ...params
  }
}

const appRequest = (request: FlyRequestConfig) => {
  // 添加token
  request.headers['Content-Type'] = 'application/json'
  const params = {
    F: phoneFrom,
    V: version,
    noncestr: `${Date.now()}`,
    ...request.body,
  }
  //根据URL，使用不同的key
  let url: any = request.url
  if (url.match(/mall/)) {
    key = mallKey//process.env.REACT_APP_MALL_KEY
  } else if (/\/baseUseMallKey\//.test(url)) {
    key = mallKey//process.env.REACT_APP_MALL_KEY
    request.url = request.url?.replace(/baseUseMallKey/, 'base')
  } else if (/^\/base\/actapi/.test(url)) {
    key = process.env.REACT_APP_PMS_KEY
  } else {
    key = '2a5f4e6ee46c26cd3dae942f5e2d2ea6'
  }

  let paramsStr = utils.formatParams({
    sign: md5(`${utils.formatParams(params)}&key=${key}`)
      .slice(3, 27)
      .toUpperCase(),
    ...params,
  })

  if (request.method === 'POST') {
    if (request.body instanceof FormData) {
      let params: any = {
        F: phoneFrom,
        V: version,
        noncestr: `${Date.now()}`,
      }

      request.headers['Content-Type'] = 'multipart/form-data'
      const entries: any = request.body.entries()
      for (let val of entries) {
        if (typeof val[1] === 'string') {
          params[val[0]] = val[1]
        }
      }
      // console.log('params', params, utils.formatParams(params), key, 
      // md5('F=iOS&V=1.8.1&data={ "contract_id":"1", "num":"12", "img":"wwww" }&noncestr=1606194816738&key=2a5f4e6ee46c26cd3dae942f5e2d2ea6').slice(3, 27).toUpperCase())
      paramsStr = utils.formatParams({
        sign: md5(`${utils.formatParams(params)}&key=${key}`)
          .slice(3, 27)
          .toUpperCase(),
        ...params,
      })
    } else {
      const params: any = {
        F: phoneFrom,
        V: version,
        noncestr: `${Date.now()}`,
        data: JSON.stringify(request.body),
      }
      const { auth } = request.body
      // const { auth, ...body } = request.body
      // request.body = body
      if (auth) {
        params['auth'] = auth
      }

      paramsStr = utils.formatParams({
        sign: md5(`${utils.formatParams(params)}&key=${key}`)
          .slice(3, 27)
          .toUpperCase(),
        ...params,
      })
    }
  } else {
    request.body = {}
  }
  request.url += `?${paramsStr}`
}

const reqIn = (request: FlyRequestConfig) => {
  if (request.url?.match('/sige/')) {
    console.log('sige1', request.url)
    sigeRequest(request)
    console.log('sige2', request.url)
  } else {
    appRequest(request)
  }

  return request
}
// 请求头拦截器
fly.interceptors.request.use(reqIn)

fly.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    // Toast.info('网络连接错误', 2, () => {
    //   if (window.WebViewBridge) {
    //     window.WebViewBridge.navBackMarket()
    //   } else if (window.webkit) {
    //     window.webkit.messageHandlers.navBackMarket.postMessage('')
    //   }
    // })
    return err
  },
)

var _typeof =
  typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
    ? function (obj: any) {
      return typeof obj
    }
    : function (obj: any) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }

const utils = {
  type: function type(ob: any) {
    return Object.prototype.toString.call(ob).slice(8, -1).toLowerCase()
  },
  isObject: function isObject(ob: any, real?: any) {
    if (real) {
      return this.type(ob) === 'object'
    } else {
      return (
        ob &&
        (typeof ob === 'undefined' ? 'undefined' : _typeof(ob)) === 'object'
      )
    }
  },
  isFormData: function isFormData(val: any) {
    return typeof FormData !== 'undefined' && val instanceof FormData
  },
  trim: function trim(str: any) {
    return str.replace(/(^\s*)|(\s*$)/g, '')
  },
  encode: function encode(val: any) {
    return encodeURIComponent(val)
      .replace(/%40/gi, '@')
      .replace(/%3A/gi, ':')
      .replace(/%24/g, '$')
      .replace(/%2C/gi, ',')
      .replace(/%20/g, '+')
      .replace(/%5B/gi, '[')
      .replace(/%5D/gi, ']')
  },
  formatParams: function formatParams(data: any) {
    var str = ''
    var first = true
    var that = this
    if (!this.isObject(data)) {
      return data
    }

    function _encode(sub: any, path: any) {
      var encode = that.encode
      var type = that.type(sub)
      if (type === 'array') {
        if (!first) {
          str += '&'
        }
        first = false
        str += path + '=' + JSON.stringify(sub)
      } else if (type === 'object') {
        const keys = Object.keys(sub).sort()
        for (let i = 0; i < keys.length; i++) {
          if (path) {
            _encode(sub[keys[i]], path + '%5B' + encode(keys[i]) + '%5D')
          } else {
            _encode(sub[keys[i]], encode(keys[i]))
          }
        }
      } else {
        if (!first) {
          str += '&'
        }
        first = false
        // str += path + "=" + encode(sub);
        str += path + '=' + sub
      }
    }

    _encode(data, '')
    return str
  },

  // Do not overwrite existing attributes
  merge: function merge(a: any, b: any) {
    for (var key in b) {
      if (!a.hasOwnProperty(key)) {
        a[key] = b[key]
      } else if (this.isObject(b[key], 1) && this.isObject(a[key], 1)) {
        this.merge(a[key], b[key])
      }
    }
    return a
  },
}

export default fly
